"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Utils = _interopRequireDefault(require("../../util/Utils"));

var _EventUtils = _interopRequireDefault(require("../../util/EventUtils.js"));

var _CancelTooltip = _interopRequireDefault(require("./../tooltips/CancelTooltip"));

var _ButtonGroup = _interopRequireDefault(require("../layout/ButtonGroup"));

var _Button = _interopRequireDefault(require("../buttons/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactPortal = require("react-portal");

var _underscore = require("underscore");

var _Icon = _interopRequireWildcard(require("./../general/Icon"));

var _Text = _interopRequireDefault(require("./../general/Text"));

var _Padding = _interopRequireWildcard(require("./../layout/Padding"));

var _FlagUtils = require("../../util/FlagUtils");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

"use strict";

/**
 * @enum {string}
 * @alias Modal.Type
 */
var Type = {
  /** basic */
  BASIC: "basic",

  /** dialog */
  DIALOG: "dialog",

  /** alert */
  ALERT: "alert"
};
/**
* @callback Modal~onClose
*/

/**
 * @class Modal
 * @desc A generic modal component. Child components of the modal are rendered as the modal content.
 *
 * @param {node} [bodyTitle]
 *     Title for inside the modal body.
 * @param {string} [data-id="modal-button"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 *
 * @param {boolean} [closeOnBgClick]
 *     When true, the onClose callback is triggered when modal bg is clicked.
 * @param {boolean} [expanded=false]
 *     Whether the modal is expanded or not.
 * @param {boolean} [maximize=false]
 *     When true, modal content will always occupy the maximum modal dimensions.
 * @param {node} [modalTitle]
 *     Title of the modal.
 * @param {boolean} [showHeader=true]
 *     Controls modal header rendering; if set to false,
 *     making modal effectively a 'light box' for previews.
 *
 * @param {object} [cancelTooltip]
 *     An object containing the props required to generate a details tooltip to confirm the closing of a modal.
 * @param {array} [flags]
 *     For new design of alert modal pass "new-alert-modal"
 * @param {Modal~onClose} [onClose]
 *     Callback to be triggered when the modal is closed by clicking the close modal link.
 *     If this function returns false then closing will be prevented.
 *     This function is set on the context as "close", for modal children (eg. the "close" button
 *     on the modal) to be able to close the modal by calling the context function.
 *
 * @param {Modal.Type} [type=Modal.Type.BASIC]
 *     Basic modal when not specified; a DIALOG modal has the "dialog" CSS class on it,
 *     same goes for the ALERT dialog.
 *
 * @example
 *      <a onClick={this._toggleModal}>Open the Modal</a>
 *      <Modal modalTitle="My wonderful modal" onClose={this._toggleModal} expanded={this.state.expanded}>
 *          <p>Thank you for opening this modal.</p>
 *      </Modal>
 */

var BaseModal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(BaseModal, _React$Component);

  var _super = _createSuper(BaseModal);

  function BaseModal() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BaseModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleKeyDown", function (e) {
      if (!_this.props.expanded) {
        return;
      }

      _EventUtils.default.callIfOutsideOfContainer(_this.refs.container, function () {
        e.stopPropagation();
        e.preventDefault();
      }, e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleBgClick", function (e) {
      var _context2;

      if (!_this.props.closeOnBgClick || !_this.props.onClose || (0, _indexOf.default)(_context2 = ["modal-content", "modal-bg"]).call(_context2, e.target.getAttribute("data-id")) === -1) {
        return;
      }

      _this.props.onClose();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getCloseButtonMarkup", function () {
      return /*#__PURE__*/_react.default.createElement("span", {
        "data-id": "close-button",
        className: "close-modal",
        onClick: _this.props.onClose
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getCloseButton", function () {
      var closeBtn;

      if (_this.props.cancelTooltip) {
        closeBtn = /*#__PURE__*/_react.default.createElement(_CancelTooltip.default, {
          "data-id": _this.props["data-id"],
          confirmButtonText: _this.props.cancelTooltip.confirmButtonText,
          cancelButtonText: _this.props.cancelTooltip.cancelButtonText,
          label: _this._getCloseButtonMarkup(),
          messageText: _this.props.cancelTooltip.messageText,
          onConfirm: _this.props.cancelTooltip.onConfirm,
          onCancel: _this.props.cancelTooltip.onCancel,
          open: _this.props.cancelTooltip.open,
          placement: "bottom left",
          title: _this.props.cancelTooltip.title
        });
      } else {
        closeBtn = _this._getCloseButtonMarkup();
      }

      return closeBtn;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_toggleIeScrollHack", function () {
      if (_this.isIeBrowser) {
        _this.showIeScrollHack = !_this.showIeScrollHack;
      }

      return _this.showIeScrollHack ? {
        height: "auto"
      } : null;
    });
    return _this;
  }

  (0, _createClass2.default)(BaseModal, [{
    key: "getChildContext",

    /*
     * Set close method into context to allow children
     * to easily close modal.
     */
    value: function getChildContext() {
      return {
        close: this.props.onClose
      };
    }
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent(open) {
      var eventName = open ? "ui-library-modal-open" : "ui-library-modal-close";
      var eventDetail = {
        component: this.displayName
      };
      var event;

      if (_Utils.default.isIE()) {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent(eventName, true, false, eventDetail);
      } else {
        event = new CustomEvent(eventName, {
          bubbles: true,
          detail: eventDetail
        });
      }

      document.body.dispatchEvent(event);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("keydown", this._handleKeyDown);
      this.isIeBrowser = _Utils.default.isIE();
      this.showIeScrollHack = false;
      this.isWizard = null;

      if (this.props.expanded) {
        this._triggerEvent(true);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.isWizard === null && this.props.expanded) {
        this.isWizard = !!document.getElementsByClassName("wizard-task").length;
        this.forceUpdate();
      }

      if (prevProps.expanded !== this.props.expanded) {
        this._triggerEvent(this.props.expanded);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("keydown", this._handleKeyDown);

      if (this.props.expanded) {
        this._triggerEvent(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.expanded) {
        return null;
      }

      var modalClasses = {
        alert: this.props.type === Type.ALERT,
        dialog: this.props.type === Type.DIALOG,
        "no-close": !this.props.onClose,
        maximize: this.props.maximize,
        show: this.props.expanded,
        "wizard-modal": this.isWizard
      };
      var showHeader = this.props.showHeader && this.props.type !== "dialog";

      var renderedModal = /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        ref: "container",
        key: "modal",
        className: (0, _classnames.default)("modal", this.props.className, modalClasses),
        role: "dialog"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-bg",
        "data-id": "modal-bg",
        onClick: this._handleBgClick
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-content",
        tabIndex: "-1",
        "data-id": "modal-content",
        onClick: this._handleBgClick
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-id": "modal-inner-content"
      }, showHeader && /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-header",
        "data-id": "modal-header"
      }, this.props.modalTitle, this.props.onClose && this._getCloseButton()), /*#__PURE__*/_react.default.createElement("div", {
        className: "modal-body",
        "data-id": "modal-body",
        style: this._toggleIeScrollHack()
      }, !showHeader && this.props.onClose && this._getCloseButton(), this.props.bodyTitle && /*#__PURE__*/_react.default.createElement(BodyTitle, null, this.props.bodyTitle), this.props.children))));

      return /*#__PURE__*/_react.default.createElement(_reactPortal.Portal, null, renderedModal);
    }
  }]);
  return BaseModal;
}(_react.default.Component);

(0, _defineProperty2.default)(BaseModal, "displayName", "Modal");
(0, _defineProperty2.default)(BaseModal, "propTypes", {
  bodyTitle: _propTypes.default.node,
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  expanded: _propTypes.default.bool,
  modalTitle: _propTypes.default.node,
  showHeader: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  closeOnBgClick: _propTypes.default.bool,
  maximize: _propTypes.default.bool,
  type: _propTypes.default.oneOf([Type.BASIC, Type.DIALOG, Type.ALERT]),
  cancelTooltip: _propTypes.default.object,
  children: _propTypes.default.node
});
(0, _defineProperty2.default)(BaseModal, "childContextTypes", {
  close: _propTypes.default.func
});
(0, _defineProperty2.default)(BaseModal, "defaultProps", {
  "data-id": "modal-button",
  expanded: false,
  showHeader: true,
  maximize: false,
  type: Type.BASIC,
  flags: []
});

var BodyTitle = function BodyTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-body__title"
  }, children);
};

BodyTitle.propTypes = {
  children: _propTypes.default.node
};

var UnsavedWarningPopup = function UnsavedWarningPopup(_ref2) {
  var children = _ref2.children,
      discardLabel = _ref2.discardLabel,
      onClose = _ref2.onClose,
      onDiscard = _ref2.onDiscard,
      onSave = _ref2.onSave,
      saveLabel = _ref2.saveLabel,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["children", "discardLabel", "onClose", "onDiscard", "onSave", "saveLabel"]);
  return /*#__PURE__*/_react.default.createElement(BaseModal, (0, _extends2.default)({}, props, {
    type: Type.ALERT
  }), /*#__PURE__*/_react.default.createElement("div", null, children), /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, {
    onCancel: onClose
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "cancel",
    onClick: onDiscard
  }, discardLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "primary",
    onClick: onSave
  }, saveLabel)));
};

UnsavedWarningPopup.propTypes = {
  bodyTitle: _propTypes.default.node,
  discardLabel: _propTypes.default.node,
  onDiscard: _propTypes.default.func,
  onSave: _propTypes.default.func,
  saveLabel: _propTypes.default.node
};
UnsavedWarningPopup.defaultProps = {
  bodyTitle: "Save Changes?",
  children: "Please save or discard your changes before leaving this page.",
  discardLabel: "Discard Changes",
  onDiscard: _underscore.noop,
  onSave: _underscore.noop,
  saveLabel: "Save"
};

function getNewAlertTitle(title) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    inline: true,
    align: _Text.default.alignments.CENTER,
    type: _Text.default.textTypes.WARNING
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    iconSize: _Icon.iconSizes.XXL,
    iconName: "alert",
    title: title
  })), /*#__PURE__*/_react.default.createElement(_Padding.default, {
    top: _Padding.sizes.LG,
    bottom: _Padding.sizes.XS
  }, title));
}

var rendersNewModal = function rendersNewModal(Component) {
  var _class, _temp;

  return _temp = _class = /*#__PURE__*/function (_React$Component2) {
    (0, _inherits2.default)(_class, _React$Component2);

    var _super2 = _createSuper(_class);

    function _class() {
      (0, _classCallCheck2.default)(this, _class);
      return _super2.apply(this, arguments);
    }

    (0, _createClass2.default)(_class, [{
      key: "render",
      value: function render() {
        return (0, _FlagUtils.hasFlag)(this, "new-alert-modal") ? /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          showHeader: false,
          bodyTitle: getNewAlertTitle(this.props.bodyTitle),
          className: (0, _classnames.default)(this.props.className, "modal--new-style")
        })) : /*#__PURE__*/_react.default.createElement(Component, this.props);
      }
    }]);
    return _class;
  }(_react.default.Component), (0, _defineProperty2.default)(_class, "contextTypes", {
    flags: _propTypes.default.arrayOf(_propTypes.default.string)
  }), _temp;
};

var Modal = rendersNewModal(BaseModal);
Modal.Type = Type;
Modal.BodyTitle = BodyTitle;
Modal.UnsavedWarningPopup = UnsavedWarningPopup;
Modal.propTypes = _objectSpread(_objectSpread({}, BaseModal.propTypes), {}, {
  flags: _FlagUtils.flagsPropType
});
Modal.defaultProps = _objectSpread(_objectSpread({}, BaseModal.defaultProps), {}, {
  flags: []
});
module.exports = Modal;